import React from "react";
import { COMPANY } from "../mock";
import { FileText } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-serif-display text-xl md:text-2xl font-bold gpm-text-green mb-3">{title}</h2>
    <div className="text-sm md:text-base text-gray-700 leading-relaxed space-y-3">{children}</div>
  </div>
);

const TermsConditions = () => {
  const updated = "June 2026";
  return (
    <div data-testid="terms-page">
      <div className="gpm-bg-green py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center gap-3 gpm-text-gold mb-3"><FileText size={22} /><span className="text-xs uppercase tracking-widest">Please read carefully</span></div>
          <h1 className="font-serif-display text-4xl md:text-5xl font-bold gpm-text-cream">Terms &amp; Conditions</h1>
          <p className="gpm-text-cream opacity-80 mt-3 text-sm">Last updated: {updated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-14">
        <Section title="1. About these terms">
          <p>These terms and conditions govern your use of the {COMPANY.name} website and any enquiry or service you request through it. By using this website you accept these terms in full. If you disagree with any part of them, please do not use the website.</p>
        </Section>

        <Section title="2. Who we are">
          <p>{COMPANY.name} is a dealer in classic and modern classic motorcars, {COMPANY.address}. You can contact us at <a href={`mailto:${COMPANY.email}`} className="gpm-text-green underline">{COMPANY.email}</a> or {COMPANY.phone}.</p>
        </Section>

        <Section title="3. Vehicle information &amp; availability">
          <p>We take care to describe our vehicles accurately, including specification, condition, history and price. However, all descriptions, photographs and prices are provided for general guidance only and do not form part of a contract.</p>
          <p>Vehicle availability is not guaranteed and any vehicle may be sold or withdrawn at any time. We recommend you contact us to confirm current availability and details before travelling or making any decision.</p>
        </Section>

        <Section title="4. Pricing">
          <p>Prices are shown in pounds sterling (£) and are subject to change without notice. Where a vehicle is marked "POA" (price on application), please contact us for the current price. A vehicle is only reserved once agreed in writing and any required deposit has been received.</p>
        </Section>

        <Section title="5. Enquiries &amp; sourcing requests">
          <p>When you submit an enquiry, contact form, or car sourcing request, you agree to provide accurate information. We will use your details to respond to you as described in our Privacy Policy. Submitting an enquiry does not create any obligation to buy or sell.</p>
        </Section>

        <Section title="6. Sales &amp; contracts">
          <p>Any sale of a vehicle is subject to a separate agreement between you and {COMPANY.name}. Nothing on this website constitutes a binding offer to sell. The terms of any purchase, including payment, deposits, part-exchange and delivery, will be confirmed with you directly.</p>
        </Section>

        <Section title="7. Intellectual property">
          <p>All content on this website — including text, logos, images and design — is owned by or licensed to {COMPANY.name} and is protected by copyright. You may not reproduce, copy or redistribute any content without our prior written permission.</p>
        </Section>

        <Section title="8. Links to other websites">
          <p>Our website may contain links to third-party websites, including our social media pages. We are not responsible for the content or privacy practices of those websites.</p>
        </Section>

        <Section title="9. Limitation of liability">
          <p>While we make every effort to keep the website accurate and available, we do not warrant that it will be error-free or uninterrupted. To the fullest extent permitted by law, {COMPANY.name} shall not be liable for any loss or damage arising from your use of, or reliance on, this website or its content. Nothing in these terms limits liability for death or personal injury caused by negligence, or for fraud.</p>
        </Section>

        <Section title="10. Governing law">
          <p>These terms are governed by the laws of England and Wales, and any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
        </Section>

        <Section title="11. Changes to these terms">
          <p>We may update these terms from time to time. The version published on this page at the time you use the website is the version that applies.</p>
        </Section>

        <Section title="12. Contact us">
          <p>If you have any questions about these terms, please contact us at <a href={`mailto:${COMPANY.email}`} className="gpm-text-green underline">{COMPANY.email}</a> or {COMPANY.phone}.</p>
        </Section>

        <p className="text-xs text-gray-400 border-t border-black/10 pt-6">These terms are provided as a general template for {COMPANY.name}. For full legal compliance we recommend having them reviewed by a qualified professional.</p>
      </div>
    </div>
  );
};

export default TermsConditions;
